export const DEFAULT_TOAST_TIMEOUT = 5000;
export const TOAST_STATE_SUCCESS = "toast-success";
export const TOAST_STATE_DANGER = "toast-danger";

export const MEDICAL_CONDITIONS = {
	NONE: "None",
};

export const DOB_YEAR = 12;
export const MAX_DOB_IN_YEARS = 30;
export const RESEND_OTP_TIMEOUT_IN_SECONDS = 30;
export const VOLUNTEER_MIN_AGE_IN_YEARS = 25;
export const VOLUNTEER_MAX_AGE_IN_YEARS = 50;

export const GENDER = [
	{
		value: "male",
		label: "male",
	},
	{
		value: "female",
		label: "female",
	},
];
export const ANCHAL = [
	"बीकानेर मारवाड़",
	"जयपुर ब्यावर",
	"मेवाड़",
	"छत्तीसगढ़ उड़ीसा",
	"मध्यप्रदेश (मालवा)",
	"बंगाल बिहार ",
	"महाराष्ट्र खानदेश विधर्भ",
	"मुंबई गुजरात",
	"दिल्ली हरयाणा पंजाब",
	"कर्नाटक तेलंगाना आंध्रप्रदेश",
	"पूर्वोत्तर",
	"तमिलनाडु",
];

export const ANCHAL_STATE_MAPPING = [
	{ state: "Rajasthan", anchal: ["बीकानेर मारवाड़", "जयपुर ब्यावर", "मेवाड़"] },
	{ state: "Chattisgarh", anchal: ["छत्तीसगढ़ उड़ीसा"] },
	{ state: "Odisha", anchal: ["छत्तीसगढ़ उड़ीसा"] },
	{ state: "Madhya Pradesh", anchal: ["मध्यप्रदेश (मालवा)"] },
	{ state: "West Bengal", anchal: ["बंगाल बिहार"] },
	{ state: "Bihar", anchal: ["बंगाल बिहार"] },
	{ state: "Nepal", anchal: ["बंगाल बिहार"] },
	{ state: "Bhutan", anchal: ["बंगाल बिहार"] },
	{ state: "Maharashtra", anchal: ["महाराष्ट्र खानदेश विधर्भ", "मुंबई गुजरात"] },
	{ state: "Gujarat", anchal: ["मुंबई गुजरात"] },
	{ state: "Delhi", anchal: ["दिल्ली हरयाणा पंजाब"] },
	{ state: "Uttarpradesh", anchal: ["दिल्ली हरयाणा पंजाब"] },
	{ state: "Haryana", anchal: ["दिल्ली हरयाणा पंजाब"] },
	{ state: "Punjab", anchal: ["दिल्ली हरयाणा पंजाब"] },
	{ state: "Uttrakhand", anchal: ["दिल्ली हरयाणा पंजाब"] },
	{ state: "Karnataka", anchal: ["कर्नाटक तेलंगाना आंध्रप्रदेश"] },
	{ state: "Andhra Pradesh", anchal: ["कर्नाटक तेलंगाना आंध्रप्रदेश"] },
	{ state: "Telengana", anchal: ["कर्नाटक तेलंगाना आंध्रप्रदेश"] },
	{ state: "Manipur", anchal: ["पूर्वोत्तर"] },
	{ state: "Arunachal Pradesh", anchal: ["पूर्वोत्तर"] },
	{ state: "Assam", anchal: ["पूर्वोत्तर"] },
	{ state: "Meghalaya", anchal: ["पूर्वोत्तर"] },
	{ state: "Nagaland", anchal: ["पूर्वोत्तर"] },
	{ state: "Tripura", anchal: ["पूर्वोत्तर"] },
	{ state: "Mizoram", anchal: ["पूर्वोत्तर"] },
	{ state: "Tamil Nadu", anchal: ["तमिलनाडु"] },
];

export const EDUCATION = [
	"School- STD-4",
	"School- STD-5",
	"School- STD-6",
	"School- STD-7",
	"School- STD-8",
	"School- STD-9",
	"School- STD-10",
	"School- STD-11",
	"School- STD-12",
	"College - Graduation",
	"College - Post Graduation",
];

export const STATES = [
	"Andaman and Nicobar Islands",
	"Andhra Pradesh",
	"Arunachal Pradesh",
	"Assam",
	"Bihar",
	"Chandigarh",
	"Chhattisgarh",
	"Dadra and Nagar Haveli",
	"Daman and Diu",
	"Delhi",
	"Goa",
	"Gujarat",
	"Haryana",
	"Himachal Pradesh",
	"Jammu and Kashmir",
	"Jharkhand",
	"Karnataka",
	"Kerala",
	"Ladakh",
	"Lakshadweep",
	"Madhya Pradesh",
	"Maharashtra",
	"Manipur",
	"Meghalaya",
	"Mizoram",
	"Nagaland",
	"Odisha",
	"Puducherry",
	"Punjab",
	"Rajasthan",
	"Sikkim",
	"Tamil Nadu",
	"Telangana",
	"Tripura",
	"Uttar Pradesh",
	"Uttarakhand",
	"West Bengal",
];

export const REGION = ["East", "West", "South", "North"];

export const VOLUNTEER_AREAS = [
	"Academic",
	"Facility",
	"Food",
	"Hostels",
	"Medical",
	"Registrations",
	"Transport",
	"Others",
];

export const STATIC_API_KEYS = {
	admin: "ADMIN-1234-5678-ABCD-EFGH",
	user: "USER-8765-4321-WXYZ-QPON",
};

export const POPUPS = {
	USER_DETAILS_POPUP: "UserDetailsPopup",
	REJECT_REQUEST_POPUP: "RejectRequestPopup",
	EDIT_USER_POPUP: "EditUserDetailsPopup",
	PERMISSION_POPUP: "PermissionAlertPopup",
};

export const USER_STATUS = {
	APPROVED: "Approved",
	REJECTED: "Rejected",
	PENDING: "Pending",
};

export const REGISTERED_SORT_OPTONS = {
	NAME_ASCENDING: "nameasc",
	NAME_DESCENDING: "namedesc",
	STATUS_ASCENDING: "statusasc",
	STATUS_DESCENDING: "statusdesc",
};

export const SORT_BY = {
	ASCENDING: "ascending",
	DESCENDING: "descending",
};

export const HTTP_GET = "GET";
export const HTTP_POST = "POST";
export const HTTP_PUT = "PUT";
export const HTTP_DELETE = "DELETE";

export const HTTP_OK = 200;
export const HTTP_CREATED = 201;
export const HTTP_NO_CONTENT = 204;

export const HTTP_NOT_MODIFIED = 304;

export const HTTP_BAD_REQUEST = 400;
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_FORBIDDEN = 403;
export const HTTP_NOT_FOUND = 404;
export const HTTP_METHOD_NOT_ALLOWED = 405;
export const HTTP_NOT_ACCEPTABLE = 406;
export const HTTP_REQUEST_TIMEOUT = 408;
export const HTTP_CONFLICT = 409;
export const HTTP_TOO_MANY_REQUESTS = 429;

export const HTTP_SERVER_ERROR = 500;
export const HTTP_NOT_IMPLEMENTED = 501;
export const HTTP_SERVICE_NOT_AVAILABLE = 503;
export const HTTP_GATEWAY_TIMEOUT = 504;
export const NO_SESSION = "no_session";

export const STATE_DANGER = "danger";
export const STATE_DEFAULT = "default";

export const HTTP_STATUS_SUCCESS = "SUCCESS";

export const RESPONSE_STATUS_CODES = {
	USER_CREATED: "USER_CREATED",
	USER_ALREADY_EXISTS: "USER_ALREADY_EXISTS",
	USER_NOT_EXISTS: "USER_NOT_EXISTS",
};

export const DEV_BASE_URL = "http://localhost:3000/";
export const BASE_URL = "https://abhimoksham.sadhumargi.com/";
export const SIGNIN_ENDPOINT = "api/auth/login";
export const ADD_USER_ENDPOINT = "api/users";
export const GET_REGISTERED_USERS_ENDPOINT = "api/users";
export const SEND_OTP_ENDPOINT = "api/send-otp";
export const VERIFY_OTP_ENDPOINT = "api/validate-otp";
export const APPROVE_USERS_ENDPOINT = "api/bulkUpdateApprovalStatus";
export const UPDATE_USER_ENDPOINT = "api/users";
export const REGISTER_VOLUNTEER_ENDPOINT = "api/volunteers";
export const FETCH_PINCODE_DETAILS_ENDPOINT = "api/getDistrictStateFromPincode";
export const CHECK_USER_ENDPOINT = "api/checkUserExists";
